<template>
  <app-layout>
    <app-header>
      <icon-link
        :href="route('home')"
        icon="arrow-thin-left-circle"
        class="icons-secondary"
      >
        Back to dashboard
      </icon-link>
      <h1>All Projects</h1>

      <template v-slot:navigation>
        <!-- <ul>
          <li>
            <a href="#" class="is-active">All applications</a>
          </li>
          <li>
            <a href="#">Approved</a>
          </li>
          <li>
            <a href="#">Rejected</a>
          </li>
          <li>
            <a href="#">Submitted</a>
          </li>
          <li>
            <a href="#">Draft</a>
          </li>
        </ul> -->
      </template>
    </app-header>
    <dashboard-section class="-mt-12">
      <template #title>
        <h3>Active Projects</h3>
      </template>
      <ul class="-mx-4 mt-4 list-reset flex flex-wrap -mx-4">
        <li
          v-for="project in projects"
          :key="project.uuid"
          class="w-full lg:w-1/3 lg:flex p-4"
        >
          <user-project-card :project="project" :user="state.user" />
        </li>
      </ul>
    </dashboard-section>
  </app-layout>
</template>

<script>
export default {
  name: "Projects",
  computed: {
    projects() {
      return this.state.projects;
    }
  },
  created() {
    document.title = `Projects :: ${document.title}`;
  }
};
</script>
